<template>
  <footer class="szw-footer">
    <div class="szw-footer__wave">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" class="w-full h-full">
        <path
          d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.83C0,95.83,161.8,71.59,321.39,56.44Z"/>
      </svg>
    </div>
    <div class="szw-footer__inner">
      <div class="szw-footer__brand">
        <span class="szw-footer__logo">Zorg &amp; Welzijn</span>
        <p class="szw-footer__tagline">© {{ new Date().getFullYear() }} Zorg &amp; Welzijn.<br/>Jouw partner in zorg.</p>
      </div>
      <div class="szw-footer__links">
        <a class="szw-footer__link" href="#">Privacy</a>
        <a class="szw-footer__link" href="#">Helpdesk</a>
        <a class="szw-footer__link" href="#">Over ons</a>
      </div>
      <div class="tw-flex gap-4">
        <button class="szw-footer__social">
          <span class="material-symbols-outlined">share</span>
        </button>
        <button class="szw-footer__social">
          <span class="material-symbols-outlined">mail</span>
        </button>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'SimplifiedFooterSamergo',
  })
</script>

<style scoped lang="scss">
  $szw-navy: #071c5b;

  .szw-footer {
    position: relative;
    margin-top: 80px;
    background: $szw-navy;
    color: white;
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  }

  .szw-footer__wave {
    position: absolute;
    top: -47px;
    left: 0;
    width: 100%;
    height: 48px;
    fill: $szw-navy;
    pointer-events: none;
  }

  .szw-footer__inner {
    max-width: 1280px;
    margin: 0 auto;
    padding: 48px 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    flex-wrap: wrap;
  }

  .szw-footer__brand {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .szw-footer__logo {
    font-size: 1.1rem;
    font-weight: 700;
    color: white;
  }

  .szw-footer__tagline {
    font-size: 0.85rem;
    color: rgba(219, 234, 254, 0.8);
    max-width: 280px;
    margin: 0;
    line-height: 1.5;
  }

  .szw-footer__links {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
  }

  .szw-footer__link {
    font-size: 0.875rem;
    color: rgba(219, 234, 254, 0.8);
    text-decoration: none;
    transition: color 0.15s;

    &:hover {
      color: white;
    }
  }

  .szw-footer__social {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }

  @media (max-width: 768px) {
    .szw-footer__inner {
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding-bottom: 96px;
    }
  }
</style>
